import { CDropdown, CDropdownToggle, CDropdownMenu, CDropdownHeader, CDropdownItem } from '@coreui/react';
import { useAppDispatch, useAppSelector } from 'app/hooks'
import Icon from 'components/icon/Icon';
import { logout, selectRol } from 'features/auth';
import { resetMenu } from 'features/menu';
import { setVisible, setVisibleSecondary } from 'features/modal';
import { LogoutConfirmModal } from 'components/modal';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ALUMNO_ROUTE, SERVER_ROUTE } from 'utils/constants';
import './AppHeaderDropdown.scss';
import { clearAlumnoDashboard } from 'features/Alumno/dashboardSlice';
import { clearFacilitadorDashboard } from 'features/Facilitador/dashboardSlice';
import { clearAlumnoEvaluacion } from 'features/Alumno/evaluacionSlice';
import { clearFacilitadorEvaluacion } from 'features/Facilitador/evaluacionSlice';
import { clearSesiones } from 'features/Alumno/sesionSlice';
import { clearAlumnoEntrega } from 'features/Alumno/entregaSlice';
import { resetAlumnoCuenta } from 'features/Alumno/cuentaSlice';
import { shallowEqual } from 'react-redux';

export const AppHeaderDropdown = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const idRol = useAppSelector((state) => selectRol(state), shallowEqual);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const isAlumno = idRol === 7;
  
  const handleLogoutClick = (e: any) => {
    e.preventDefault();
    setShowLogoutModal(true);
  };

  const handleLogoutConfirm = () => {
    dispatch(clearAlumnoDashboard());
    dispatch(clearAlumnoEvaluacion());
    dispatch(clearSesiones());
    dispatch(clearAlumnoEntrega());
    dispatch(resetAlumnoCuenta());

    dispatch(clearFacilitadorDashboard());
    dispatch(clearFacilitadorEvaluacion());

    dispatch(logout());
    dispatch(setVisibleSecondary(false));
    dispatch(setVisible(false));
    dispatch(resetMenu());
    setShowLogoutModal(false);
  };

  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };

  const handleAccountClick = (e: any) => {
    e.preventDefault();
    navigate(`${SERVER_ROUTE}${ALUMNO_ROUTE}/mi-cuenta`);
  };

  return (
    <CDropdown variant="nav-item" className="header-dropdown mt-4">
      <CDropdownToggle className="header-dropdown-toggle" caret={false}>
        <div className="user-avatar">
          <Icon icono="mdiAccountCircle" size={1.3} className="avatar-icon" />
        </div>
      </CDropdownToggle>
      
      <CDropdownMenu className="header-dropdown-menu">

        {isAlumno && (
          <CDropdownItem className="dropdown-item-custom account-item" onClick={handleAccountClick}>
            <div className="d-flex align-items-center">
              <Icon icono="mdiAccountBoxOutline" size={0.9} className="me-2 account-icon" />
              <span>Ver mi cuenta</span>
            </div>
          </CDropdownItem>
        )}

        <CDropdownItem className="dropdown-item-custom" onClick={handleLogoutClick}>
          <div className="d-flex align-items-center">
            <Icon icono="mdiLogout" size={0.9} className="me-2 logout-icon" />
            <span>Cerrar sesión</span>
          </div>
        </CDropdownItem>
      </CDropdownMenu>
      
      <LogoutConfirmModal
        isOpen={showLogoutModal}
        onConfirm={handleLogoutConfirm}
        onCancel={handleLogoutCancel}
      />
    </CDropdown>
  )
}
